<div class="project-component">

  <div style="display: flex; flex-direction: row; justify-content: space-between; align-items: start">
    <div *ngIf="project">
      <h2 style="font-family: Roboto, 'Helvetica Neue', sans-serif;">Project: {{project.name}}</h2>
    </div>

    <div style="display: flex; flex-direction: row; margin-top: 16px;align-items:center;">
      <div style="margin-right:100px;">
        <mat-form-field>
          <mat-label>Filter</mat-label>
          <input matInput type="text" [(ngModel)]="filter" (keyup)="filterItems()" />
        </mat-form-field>
      </div>
      <button mat-raised-button [matMenuTriggerFor]="appMenu"
              style="border-radius: 6px;margin-right: 10px;white-space: nowrap; "
              class="button" *ngIf="!isVendor">
        Actions<span class="mat-select-arrow"
                     style="display:inline-block; width: 0;height: 0;border-left: 5px solid transparent;border-right: 5px solid transparent;border-top: 5px solid;margin: 0 4px;"></span>
      </button>
      <mat-menu #appMenu="matMenu">
        <button *ngIf="isSspEnabled"
                (click)="generateActionPlan()"
                mat-menu-item>
          Generate SSP
        </button>
        <button (click)="editProject()"
                mat-menu-item *ngIf="canEditProject">
          <i class="pi pi-pencil"></i>
          Edit Project
        </button>
        <button *ngIf="project && project.clientITProfileIds && project.clientITProfileIds.length > 0"
                [routerLink]="['/profiles/itProfile', project.clientITProfileIds.split(';')[0]]"
                mat-menu-item>
          View Boundary Profile
        </button>
        <button mat-menu-item [matMenuTriggerFor]="reportMenu">
          Reports
        </button>
        <button mat-menu-item [matMenuTriggerFor]="advancedMenu" *ngIf="canEditProject">
          Advanced Options
        </button>
        <button mat-menu-item *ngIf="canEditProject"
                [routerLink]="['/projects/policy', projectId]">
          Assign Policies
        </button>
        <button mat-menu-item *ngIf="canEditProject"
                [routerLink]="['/projects/poams', projectId]">
          Assign POAMs
        </button>
        <button mat-menu-item *ngIf="canEditProject"
                [routerLink]="['/projects/projectNew', projectId]">
          Classic PLV
        </button>
        <button [routerLink]="['/projects/project', projectId, 'assessments']"
                mat-menu-item>
          Assessment Manager
        </button>
      </mat-menu>
    </div>
  </div>

  <mat-menu #reportMenu="matMenu">
    <button (click)="generateCRM()"
            mat-menu-item>
      FedRAMP CRM
    </button>
    <button (click)="onPoamView()"
            mat-menu-item>
      Gap Report
    </button>
    <button [routerLink]="['/projects/poam/edit', projectId]"
            mat-menu-item>
      Gap Grid
    </button>
    <button [routerLink]="['/projects/sharedResponsibilityReport', projectId]"
            mat-menu-item>
      Shared Responsibility
    </button>
    <button [routerLink]="['/projects/cidreport', projectId]"
            mat-menu-item>
      Control Item Detail
    </button>
    <button [routerLink]="['status']"
            mat-menu-item>
      Activity
    </button>
    <button mat-menu-item
            (click)="showScoringReport()">
      Scoring Report
    </button>
    <button [routerLink]="['/projects/assessmentFindings', projectId]"
            mat-menu-item>
      Assessment View
    </button>
    <button [routerLink]="['/projects/thirdPartyAssessment', projectId]"
            mat-menu-item>
      3rd Party Security Assessment View
    </button>
  </mat-menu>
  <input #inputFile
         type="file"
         (change)="uploadProjectData($event)"
         [style.display]="'none'">
  <input #inputFilePoam
         type="file"
         (change)="uploadPoamData($event)"
         [style.display]="'none'">

  <mat-menu #advancedMenu="matMenu">
    <button (click)="openAccessRightsPopup()"
            mat-menu-item *ngIf="canEditProject">
      Access Rights
    </button>
    <button mat-menu-item *ngIf="canEditProject"
            (click)="inputFile.click()">
      <i class="pi pi-paperclip"></i>
      Import Project Data
    </button>
    <button mat-menu-item *ngIf="canEditProject"
            (click)="window.location.href= config.api + '/api/project/download?projectId=' + projectId + '&token=' + userToken">
      <i class="pi pi-paperclip"></i>
      Export Project Data
    </button>
    <button mat-menu-item *ngIf="canEditProject"
            (click)="inputFilePoam.click()">
      <i class="pi pi-paperclip"></i>
      Import POA&Ms
    </button>
    <button mat-menu-item *ngIf="canEditProject"
            (click)="window.location.href= config.api + '/api/project/download/poam?projectId=' + projectId + '&token=' + userToken">
      <i class="pi pi-paperclip"></i>
      Export POA&Ms
    </button>
    <button mat-menu-item *ngIf="canEditProject && isRizkMapEnabled"
            [routerLink]="['/projects/project', projectId, 'mapControlItems']">
      RizkMap
    </button>
  </mat-menu>


  <div style="display: flex; flex-direction: row;">
    <div *ngIf="dotsExpanded" style="flex:0 0 350px">
      <p-table [value]="remainingControlItems"
               *ngIf="projectControlItems && projectControlItems.length > 0"
               [(selection)]="selectedItem"
               exportFilename="project"
               dataKey="projectControlItemId"
               scrollHeight="calc(100vh - 290px)"
               [scrollable]="true"
               [reorderableColumns]="true">

        <ng-template pTemplate="header">
          <tr>
            <th>Control</th>
            <th style="width: 2em;" pTooltip="Implementation Control Statement">IS</th>
            <th style="width: 2em;" pTooltip="Policy &amp; Procedures">PP</th>
            <th style="width: 2em;" pTooltip="Evidence">E</th>
            <th style="width: 2em;" pTooltip="Gaps">G</th>
            <th style="width: 2em;" pTooltip="Workstreams">W</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-item let-rowIndex="rowIndex">
          <tr class="status-row"
              *ngIf="(!item.controlItem.parentControlItemId || expandedSmallItem[item.controlItem.parentControlItemId]) && (item.controlItem.parentControlItemId || (!item.subItems.length || project.displayParentRows && !project.isParentContainer))">
            <td (click)="selectItem(item)" [ngStyle]="{'padding-left': item.controlItem.parentControlItemId ? '25px' : '0.5em'}">
              <i [ngClass]="expandedSmallItem[item.controlItem.controlItemId] ? 'fa fa-fw fa-chevron-circle-down' : 'fa fa-fw fa-chevron-circle-right'"
                 [ngStyle]="{'display': item.subItems && item.subItems.length ? 'inline-block' : 'none'}"
                 (click)="expandedSmallItem[item.controlItem.controlItemId] = !expandedSmallItem[item.controlItem.controlItemId]; $event.stopPropagation(); $event.preventDefault();"></i>
              {{item.controlItem.complianceAreaControlId}}
            </td>
            <td style="width: 2em; text-align: center;cursor: pointer;" class="{{item.implementationStatusStyle}}" (click)="editControlItem(item.projectControlItemId, null, 2, 0)"></td>
            <td style="width: 2em; text-align: center;cursor: pointer;" class="{{item.policyNotNeeded ? 'gray' : item.projectControlItemPolicies?.length > 0 ? 'green' : 'red'}}" (click)="editControlItem(item.projectControlItemId, null, 3, 1)"></td>
            <td style="width: 2em; text-align: center;cursor: pointer;" class="{{item.evidencesStyle}}" (click)="editControlItem(item.projectControlItemId, null, 3, 0)"></td>
            <td style="width: 2em; text-align: center;cursor: pointer; position:relative;" class="{{item.gapStyle}}" (click)="editControlItem(item.projectControlItemId, null, 2, 3)"><div style="position:absolute;top:0;left:0;right:0;bottom:0;background-color: rgba(255, 255, 255, 0.0001);" [pTooltip]="item.gapCount" tooltipPosition="top"></div></td>
            <td style="width: 2em; text-align: center;cursor: pointer;" [pTooltip]="'Green: ' + item.greenCount + ', Orange: ' + item.orangeCount + ', Red: ' + item.redCount" class="{{item.workstreamStatus}}" (click)="clickOnWorkstreamDot(item.controlItem.controlItemId)"></td>
          </tr>
          <tr *ngIf="item.subItems.length && !item.controlItem.parentControlItemId && project.isParentContainer && project.displayParentRows">
            <td [ngStyle]="{'padding-left': item.controlItem.parentControlItemId ? '20px' : '0.5em'}">
              <i *ngIf="item.subItems.length" [ngClass]="expandedSmallItem[item.controlItem.controlItemId] ? 'fa fa-fw fa-chevron-circle-down' : 'fa fa-fw fa-chevron-circle-right'"
                 [ngStyle]="{'display': item.subItems && item.subItems.length ? 'inline-block' : 'none'}"
                 (click)="expandedSmallItem[item.controlItem.controlItemId] = !expandedSmallItem[item.controlItem.controlItemId]; $event.stopPropagation(); $event.preventDefault();"></i>
              {{item.controlItem.complianceAreaControlId}}
            </td>
            <td style="width: 2em; text-align: center;"></td>
            <td style="width: 2em; text-align: center;"></td>
            <td style="width: 2em; text-align: center;"></td>
            <td style="width: 2em; text-align: center;"></td>
          </tr>
        </ng-template>
      </p-table>
    </div>
    <div style="flex:0 0 16px" class="dot-toggler" (click)="dotsExpanded = !dotsExpanded">
      <span>{{dotsExpanded ? '<' : '>'}}</span>
    </div>
    <div style="flex:1 1 auto; padding-left: 10px;">
      <p-table [value]="remainingControlItems"
               *ngIf="!isVendor && remainingControlItems && remainingControlItems.length > 0"
               #table
               [reorderableColumns]="true"
               [columns]="cols"
               [resizableColumns]="true"
               exportFilename="project"
               dataKey="controlItem.category"
               [expandedRowKeys]="expandedCategories"
               (onSort)="updateRowGroupMetaData(table.filteredValue || table.value, 'remainingControlItems')"
               (onFilter)="updateRowGroupMetaData($event.filteredValue, 'remainingControlItems')"
               scrollHeight="calc(100vh - 362px)"
               [scrollable]="true">

        <ng-template pTemplate="caption">
          <div class="ui-helper-clearfix" style="display: flex;">
            <div style="flex: 1 1 auto; text-align: left">
              <button type="button"
                      pButton
                      class="risksponge-button"
                      icon="pi pi-file-excel"
                      iconPos="left"
                      (click)="table.exportCSV()">
              </button>
              <button type="button"
                      pButton
                      class="risksponge-button"
                      icon="pi pi-list"
                      iconPos="left"
                      title="Expand/Collapse all"
                      (click)="toggleItems()"></button>
              <button type="button"
                      pButton
                      class="risksponge-button"
                      icon="pi pi-briefcase"
                      iconPos="left"
                      title="Open Profile"
                      *ngIf="project.clientITProfileIds && project.clientITProfileIds.length"
                      [routerLink]="['/profiles/itProfile', project.clientITProfileIds[0]]"></button>
            </div>
            <div style="flex: 0 0 auto">
              <p-multiSelect [options]="columnOptions"
                             [(ngModel)]="cols"
                             (onChange)="onPanelHide()">
                <ng-template let-value pTemplate="selectedItems">
                  {{visibleColumns}} items selected
                </ng-template>
              </p-multiSelect>
            </div>
          </div>
        </ng-template>
        <ng-template pTemplate="header">
          <tr [ngStyle]="{'white-space': 'nowrap', 'font-weight': 'bold'}">
            <ng-container *ngFor="let col of cols">
              <ng-container *ngIf="col.field != 'parentName' || !project.displayParentRows">
                <th [pSortableColumn]="col.field" [ngStyle]="{'width': col.width || 'auto'}" style="white-space: nowrap;"
                    *ngIf="col.field != 'controlItem.level' || anyAreaWithLevels" pResizableColumn pReorderableColumn>
                  {{col.header}}
                  <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
                              ariaLabelDesc="Activate to sort in descending order"
                              ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                </th>
              </ng-container>
            </ng-container>
            <th></th>
          </tr>
          <tr>
            <ng-container *ngFor="let col of cols">
              <th [ngSwitch]="col.field" *ngIf="(col.field != 'controlItem.level' || anyAreaWithLevels) && (col.field != 'parentName' || !project.displayParentRows)">
                <input *ngSwitchDefault pInputText type="text" placeholder="⌕"
                       (input)="table.filter($event.target['value'], col.field, 'contains')">
                <ng-container *ngSwitchCase="'parentName'">
                  <ng-container *ngIf="!project.displayParentRows">
                    <input pInputText type="text" placeholder="⌕"
                           (input)="table.filter($event.target['value'], col.field, 'contains')">
                  </ng-container>
                </ng-container>
                <span *ngSwitchCase="'dueDate'">
                  <input pInputText type="text" placeholder="⌕"
                         (input)="table.filter($event.target['value'], col.field, 'date')">
                </span>
                <p-multiSelect *ngSwitchCase="'controlItem.category'" multiple
                               [options]="categoryFilterOptions"
                               [style]="{'width':'100%'}"
                               (onChange)="table.filter($event.value, 'controlItem.category', 'in')"></p-multiSelect>

                <p-multiSelect *ngSwitchCase="'currentRangeCompleted'" [options]="booleanFilterOptions"
                               defaultLabel="All"
                               (onChange)="table.filter($event.value,col.field,'in')"
                               styleClass="ui-column-filter">
                </p-multiSelect>
                <p-multiSelect *ngSwitchCase="'assignedClient.userId'" [options]="clients" dataKey="userId"
                               optionLabel="fullName"
                               defaultLabel="All"
                               [style]="{'width':'100%'}"
                               (onChange)="table.filter(filterUser($event.value),col.field,'in')"
                               styleClass="ui-column-filter">
                </p-multiSelect>
                <p-multiSelect *ngSwitchCase="'reviewedByConsultant'" [options]="booleanFilterOptions"
                               defaultLabel="All"
                               (onChange)="table.filter($event.value,col.field,'in')"
                               styleClass="ui-column-filter">
                </p-multiSelect>
                <p-multiSelect *ngSwitchCase="'implementationStatusText'" [options]="implementationStatusFilterOptions"
                               [style]="{'width':'100%'}"
                               defaultLabel="All"
                               (onChange)="table.filter($event.value,col.field,'in')"
                               styleClass="ui-column-filter">
                </p-multiSelect>
              </th>
            </ng-container>
          </tr>
        </ng-template>

        <ng-template pTemplate="colgroup" let-columns>
          <colgroup>
            <ng-container *ngFor="let col of cols">
              <col *ngIf="(col.field != 'controlItem.level' || anyAreaWithLevels) && (col.field != 'parentName' || !project.displayParentRows)" [style.width]="col.width">
            </ng-container>
          </colgroup>
        </ng-template>

        <ng-template pTemplate="body" let-item let-rowIndex="rowIndex" let-expanded="expanded" let-columns="columns">
          <tr *ngIf="rowIndex == 0">
            <ng-container *ngFor="let col of cols">
              <td *ngIf="(col.field != 'controlItem.level' || anyAreaWithLevels) && (col.field != 'parentName' || !project.displayParentRows)" [ngStyle]="{'width': col.width || 'auto'}" class="ui-resizable-column"></td>
            </ng-container>
            <td></td>
          </tr>
          <tr class="ui-widget-header"
              *ngIf="rowGroupMetadata['remainingControlItems'] && rowGroupMetadata['remainingControlItems'][item.controlItem.category].index === rowIndex">
            <td [attr.colspan]="cols.length + 2">
              <a href="#" [pRowToggler]="item">
                <i [ngClass]="expanded ? 'fa fa-fw fa-chevron-circle-down' : 'fa fa-fw fa-chevron-circle-right'"></i>
                <span>
                  {{item['controlItem'].complianceArea.name}} - {{item['controlItem'].category}}<span style="margin-left: 20px; float: right; width: 10%; font-style: italic; font-weight: bold;">PM = {{rowGroupMetadata['remainingControlItems'][item.controlItem.category].maturity / rowGroupMetadata['remainingControlItems'][item.controlItem.category].size | number : "0.0-2"}}</span>
                </span>
              </a>
            </td>
          </tr>
        </ng-template>

        <ng-template pTemplate="expandedrow" let-item let-rowIndex="rowIndex" let-expanded="expanded" let-columns="columns">
          <tr [attr.id]="'cidrow' + item.projectControlItemId"
              *ngIf="(!item.controlItem.parentControlItemId || expandedItem[item.controlItem.parentControlItemId]) && (item.controlItem.parentControlItemId || (!item.subItems.length || project.displayParentRows && !project.isParentContainer))">
            <ng-container *ngFor="let col of cols" [ngSwitch]="col.field">
              <td *ngSwitchCase="'controlItem.complianceAreaControlId'"
                  [ngStyle]="{'padding-left': item.controlItem.parentControlItemId ? '20px' :  '0.5em'}" class="ui-resizable-column">
                <i [ngClass]="expandedItem[item.controlItem.controlItemId] ? 'fa fa-fw fa-chevron-circle-down' : 'fa fa-fw fa-chevron-circle-right'"
                   [ngStyle]="{'visibility': item.subItems && item.subItems.length ? 'visible' : 'hidden'}"
                   (click)="expandedItem[item.controlItem.controlItemId] = !expandedItem[item.controlItem.controlItemId]"></i>
                <a href="javascript:return false;" (click)="editControlItem(item.projectControlItemId, null)">
                  {{item.controlItem.complianceAreaControlId}}
                </a>
                <span class="modified"
                      style="font-size: 16px; color: var(--main-ui-color, orange);margin-right: 8px;"
                      *ngIf="item.lastModifiedDate && item.lastModifiedDate > currentUser.previousLoginTime"
                      pTooltip="Modified by {{item.lastModifiedBy}} on {{formatDate(item.lastModifiedDate)}}"
                      tooltipPosition="top"></span>
                <span class="reviewed" style="font-size: 16px; color: var(--main-ui-color, orange);"
                      *ngIf="item.lastReviewedDate && item.lastReviewedDate > minReviewedDate && !item.reviewRequired && !isUserAdvisor"
                      pTooltip="Reviewed by {{item.lastReviewedBy}} on {{formatDate(item.lastReviewedDate)}}"
                      tooltipPosition="top"></span>
                <span class="reviewed" style="font-size: 16px; color: var(--main-ui-color, orange);"
                      *ngIf="item.reviewRequired && isUserAdvisor"
                      pTooltip="Requires review"
                      tooltipPosition="top"></span>
              </td>
              <td *ngSwitchCase="'responsibility'"
                  (click)="expandedDetails[item.projectControlItemId] = !expandedDetails[item.projectControlItemId]" class="ui-resizable-column">
                {{item.responsibility}}
              </td>
              <td *ngSwitchCase="'amazon'" (click)="expandedDetails[item.projectControlItemId] = !expandedDetails[item.projectControlItemId]"
                  style="text-align: center; width: 5em;">
                <div *ngIf="item.responsibility == 'Shared' && item.vendor == 'AWS'"
                     style="width: 9px;height: 16px; border-top-left-radius: 9px; border-bottom-left-radius: 9px; border: 1px solid black; background-color: var(--main-ui-color, orange); display: inline-block;padding-right: 7px;"></div>
                <div *ngIf="item.responsibility == 'Inherited' && item.vendor == 'AWS'"
                     style="width: 16px;height: 16px; border-radius: 8px; border: 1px solid black; background-color: var(--main-ui-color, orange); display: inline-block;"></div>
              </td>
              <td *ngSwitchCase="'azure'" (click)="expandedDetails[item.projectControlItemId] = !expandedDetails[item.projectControlItemId]"
                  style="text-align: center; width: 5em;" class="ui-resizable-column">
                <div *ngIf="item.responsibility == 'Shared' && item.vendor == 'Azure'"
                     style="width: 9px;height: 16px; border-top-left-radius: 9px; border-bottom-left-radius: 9px; border: 1px solid black; background-color: green; display: inline-block;padding-right: 7px;"></div>
                <div *ngIf="item.responsibility == 'Inherited' && item.vendor == 'Azure'"
                     style="width: 16px;height: 16px; border-radius: 8px; border: 1px solid black; background-color: green; display: inline-block;"></div>
              </td>
              <td *ngSwitchCase="'ibm'" (click)="expandedDetails[item.projectControlItemId] = !expandedDetails[item.projectControlItemId]"
                  style="text-align: center; width: 5em;" class="ui-resizable-column">
              </td>
              <td *ngSwitchCase="'controlItem.category'"
                  (click)="expandedDetails[item.projectControlItemId] = !expandedDetails[item.projectControlItemId]" class="ui-resizable-column">
                <i class="pi pi-bell" (click)="openSendMessage(item)" style="cursor: pointer;"></i>
                {{item.controlItem.category}}
              </td>
              <td *ngSwitchCase="'controlItem.shortName'"
                  (click)="expandedDetails[item.projectControlItemId] = !expandedDetails[item.projectControlItemId]" class="ui-resizable-column">
                {{item.controlItem?.shortName || (item.controlItem?.desctiption | slice: 0: 100)}}
              </td>
              <ng-container *ngSwitchCase="'controlItem.level'">
                <td *ngIf="anyAreaWithLevels"
                    (click)="expandedDetails[item.projectControlItemId] = !expandedDetails[item.projectControlItemId]" style="text-align: center;" class="ui-resizable-column">
                  {{item.controlItem.level}}
                </td>
              </ng-container>
              <ng-container *ngSwitchCase="'priority'">
                <td (click)="expandedDetails[item.projectControlItemId] = !expandedDetails[item.projectControlItemId]" style="text-align: center;" class="ui-resizable-column">{{item.priorityText}}</td>
              </ng-container>
              <ng-container *ngSwitchCase="'parentName'">
                <td *ngIf="!project.displayParentRows"
                    (click)="expandedDetails[item.projectControlItemId] = !expandedDetails[item.projectControlItemId]" style="text-align: center;" class="ui-resizable-column">
                  {{item.parentName}}
                </td>
              </ng-container>
              <td *ngSwitchCase="'assignedClient.userId'"
                  (click)="expandedDetails[item.projectControlItemId] = !expandedDetails[item.projectControlItemId]" class="ui-resizable-column">
                {{getFullName(item.assignedClient)}}
              </td>
              <td *ngSwitchCase="'mapping'" [pRowToggler]="item" class="ui-resizable-column">
                <ul style="padding-left: 2em;">
                  <li *ngFor="let source of item.sources">
                    {{source.fromProjectName}}
                    - {{source.fromControlItemName}}
                  </li>
                </ul>
              </td>
              <td *ngSwitchCase="'targetMapping'" (click)="expandedDetails[item.projectControlItemId] = !expandedDetails[item.projectControlItemId]" class="ui-resizable-column">
                <ul style="padding-left: 2em;">
                  <li *ngFor="let target of item.targets">{{target.toProjectName}} - {{target.toControlItemName}}</li>
                </ul>
              </td>

              <td *ngSwitchCase="'implementationStatusText'" (click)="expandedDetails[item.projectControlItemId] = !expandedDetails[item.projectControlItemId]" class="ui-resizable-column">
                {{item.implementationStatusText}}
              </td>

              <td *ngSwitchCase="'dueDate'" (click)="expandedDetails[item.projectControlItemId] = !expandedDetails[item.projectControlItemId]" class="ui-resizable-column">
                {{item.upcomingDueDate | date : 'shortDate'}}
              </td>

              <td *ngSwitchCase="'recurring'" (click)="expandedDetails[item.projectControlItemId] = !expandedDetails[item.projectControlItemId]" class="ui-resizable-column">
                {{recurringList[item.recurring].label}}
              </td>

              <td *ngSwitchCase="'currentRangeCompleted'" style="text-align: center;"
                  (click)="expandedDetails[item.projectControlItemId] = !expandedDetails[item.projectControlItemId]" class="ui-resizable-column">
                <mat-checkbox [(ngModel)]="item.currentRangeCompleted"
                              name="completedRow"
                              disabled>
                </mat-checkbox>
              </td>

              <td *ngSwitchCase="'reviewRequired'" style="text-align: center;"
                  (click)="expandedDetails[item.projectControlItemId] = !expandedDetails[item.projectControlItemId]" class="ui-resizable-column">
                <mat-checkbox [(ngModel)]="item.reviewRequired"
                              name="reviewRequired"
                              disabled>
                </mat-checkbox>
              </td>
              <td *ngSwitchCase="'riskNumber'" style="text-align: center;"
                  (click)="expandedDetails[item.projectControlItemId] = !expandedDetails[item.projectControlItemId]" class="ui-resizable-column">
                {{item.riskNumber}}
              </td>
              <td *ngSwitchCase="'classification'" style="text-align: center;"
                  (click)="expandedDetails[item.projectControlItemId] = !expandedDetails[item.projectControlItemId]" class="ui-resizable-column">
                {{item.controlItem.isLow ? 'L' : ''}}
                {{item.controlItem.isMedium ? 'M' : ''}}
                {{item.controlItem.isHigh ? 'H' : ''}}
              </td>
              <td *ngSwitchCase="'score'" style="text-align: center;"
                  (click)="expandedDetails[item.projectControlItemId] = !expandedDetails[item.projectControlItemId]" class="ui-resizable-column">
                {{item.score}}/{{item.controlItem.value}}
              </td>
              <td *ngSwitchCase="'assessmentActive'" style="text-align: center;"
                  (click)="expandedDetails[item.projectControlItemId] = !expandedDetails[item.projectControlItemId]" class="ui-resizable-column">
                {{item.assessmentActive ? 'Active' : ''}}
              </td>
              <td *ngSwitchCase="'cr'" style="text-align: center;"
                  (click)="expandedDetails[item.projectControlItemId] = !expandedDetails[item.projectControlItemId]" class="ui-resizable-column">
                {{item.cr}}
              </td>
              <td *ngSwitchCase="'lastModifiedDate'" style="text-align: center;"
                  (click)="expandedDetails[item.projectControlItemId] = !expandedDetails[item.projectControlItemId]" class="ui-resizable-column">
                {{item.lastModifiedDate | date : 'shortDate'}} {{item.lastModifiedDate | date : 'shortTime'}}
              </td>
              <td *ngSwitchCase="'controlType_'" style="text-align: center;"
                  (click)="expandedDetails[item.projectControlItemId] = !expandedDetails[item.projectControlItemId]" class="ui-resizable-column">
                {{item.controlType_}}
              </td>
              <td *ngSwitchCase="'dynamicScore'" style="text-align: center;"
                  (click)="expandedDetails[item.projectControlItemId] = !expandedDetails[item.projectControlItemId]" class="ui-resizable-column">
                {{item.dynamicScore}}
              </td>
            </ng-container>
          </tr>
          <tr [attr.id]="'cidrow' + item.projectControlItemId" *ngIf="item.subItems.length && !item.controlItem.parentControlItemId && project.isParentContainer && project.displayParentRows">
            <ng-container *ngFor="let col of cols" [ngSwitch]="col.field">
              <td *ngSwitchCase="'controlItem.complianceAreaControlId'" class="ui-resizable-column">
                <i *ngIf="item.subItems" [ngClass]="expandedItem[item.controlItem.controlItemId] ? 'fa fa-fw fa-chevron-circle-down' : 'fa fa-fw fa-chevron-circle-right'"
                   [ngStyle]="{'visibility': item.subItems && item.subItems.length ? 'visible' : 'hidden'}"
                   (click)="expandedItem[item.controlItem.controlItemId] = !expandedItem[item.controlItem.controlItemId]"></i>
                {{item.controlItem.complianceAreaControlId}}
              </td>
              <td *ngSwitchCase="'controlItem.category'" class="ui-resizable-column">
                {{item.controlItem.category}}
              </td>
              <td *ngSwitchDefault></td>
            </ng-container>
          </tr>
          <tr *ngIf="expandedDetails[item.projectControlItemId]">
            <td [attr.colspan]="visibleColumns">
              <div style="display: flex; flex-direction: row; justify-content: space-between">
                <div style="flex:0 0 auto">
                  <mat-form-field>
                    <mat-label>Control ID</mat-label>
                    <input matInput type="text" [value]="item.controlItem.complianceAreaControlId" readonly>
                  </mat-form-field>
                </div>
                <div style="flex:0 0 auto">
                  <mat-form-field>
                    <mat-label>Due Date</mat-label>
                    <input matInput
                           [matDatepicker]="picker"
                           [(ngModel)]="item.upcomingDueDate"
                           name="rowDueDate"
                           (dateChange)="onNodeDateChanged('change', $event, item)">

                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                  </mat-form-field>
                </div>
                <div style="flex:0 0 auto">
                  <mat-form-field class="example-full-width">
                    <mat-label>Implementation Status</mat-label>
                    <mat-select [(ngModel)]="item.implementationStatus"
                                name="implementationStatus"
                                (selectionChange)="updateProjectControlItem(item)">
                      <mat-option [value]="0">None</mat-option>
                      <mat-option [value]="1">Implemented</mat-option>
                      <mat-option [value]="2">Partially Implemented</mat-option>
                      <mat-option [value]="3">Planned</mat-option>
                      <mat-option [value]="4">Alternative Implementation</mat-option>
                      <mat-option [value]="5">Not Applicable</mat-option>
                      <mat-option [value]="7">Not Implemented</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div style="flex:0 0 auto">
                  <div style="color: rgba(0, 0, 0, 0.54); font-size: 12px;transform-origin: 0 0; transform: translateY(-1.28125px) scale(.75) perspective(100px) translateZ(0.001px);font-size: 16.8px;">
                    Policy &amp; Procedures
                  </div>
                  <ul style="padding-left: 18px;">
                    <li *ngFor="let policy of item.policies">{{policy.name}}</li>
                  </ul>
                </div>
              </div>
              <div *ngIf="item.assessmentNotes && item.assessmentNotes.length">
                <div (click)="expandedStatus['Assessment' + item.projectControlItemId] = !expandedStatus['Assessment' + item.projectControlItemId]">
                  <i [ngClass]="expandedStatus['Assessment' + item.projectControlItemId] ? 'fa fa-fw fa-chevron-circle-down' : 'fa fa-fw fa-chevron-circle-right'"></i>
                  Open Assessment Findings
                </div>
                <table *ngIf="expandedStatus['Assessment' + item.projectControlItemId]"
                       class="ui-table-scrollable-header-table" style="margin: 5px 0">
                  <thead class="ui-table-thead">
                    <tr style="font-size: 8px;">
                      <th style="width: 10em;">Date</th>
                      <th style="width: 40%;">Finding</th>
                      <th>Recommendations</th>
                      <th style="width: 10%;">Status</th>
                    </tr>
                  </thead>
                  <tbody class="ui-table-tbody">
                    <tr *ngFor="let assessmentNote of item.assessmentNotes">
                      <td style="font-size: 12px;">Due {{assessmentNote.date | date:'shortDate'}}</td>
                      <td style="font-size: 12px;">{{assessmentNote.finding}}</td>
                      <td style="font-size: 12px;">{{assessmentNote.recommendations}}</td>
                      <td style="font-size: 12px;">{{assessmentNoteStatuses[assessmentNote.status]}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div *ngIf="item.solutionDescription && item.solutionDescription.length">
                <div (click)="expandedStatus['ImplementationControlStatement' + item.projectControlItemId] = !expandedStatus['ImplementationControlStatement' + item.projectControlItemId]">
                  <i [ngClass]="expandedStatus['ImplementationControlStatement' + item.projectControlItemId] ? 'fa fa-fw fa-chevron-circle-down' : 'fa fa-fw fa-chevron-circle-right'"></i>
                  Open Implementation Control Statement
                </div>
                <div *ngIf="expandedStatus['ImplementationControlStatement' + item.projectControlItemId]" [innerHTML]="addToken(item.solutionDescription) | sanitizeHtml"></div>
              </div>
              <div *ngIf="item.actionPlans && item.actionPlans.length">
                <div (click)="expandedStatus['actionPlan' + item.projectControlItemId] = !expandedStatus['actionPlan' + item.projectControlItemId]">
                  <i [ngClass]="expandedStatus['actionPlan' + item.projectControlItemId] ? 'fa fa-fw fa-chevron-circle-down' : 'fa fa-fw fa-chevron-circle-right'"></i>
                  Open POAMs
                </div>
                <table *ngIf="expandedStatus['actionPlan' + item.projectControlItemId]"
                       class="ui-table-scrollable-header-table" style="margin: 5px 0">
                  <thead class="ui-table-thead">
                    <tr style="font-size: 8px;">
                      <th style="width: 10em;">Date</th>
                      <th style="width: 40%;">Weakness Description</th>
                      <th>Remediation Plans, Actions and Milestones</th>
                      <th style="width: 10%;">Status</th>
                    </tr>
                  </thead>
                  <tbody class="ui-table-tbody">
                    <tr *ngFor="let actionPlan of item.actionPlans">
                      <td style="font-size: 12px;">Due {{actionPlan.scheduledCompletionDate | date:'shortDate'}}</td>
                      <td style="font-size: 12px;">{{actionPlan.weaknessDescription}}</td>
                      <td style="font-size: 12px;">{{actionPlan.remediationPlansActionsMilestones}}</td>
                      <td style="font-size: 12px;">{{actionItemStatuses[actionPlan.currentStatus]}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div *ngIf="item.evidences && item.evidences.length">
                <div (click)="expandedStatus['Evidence' + item.projectControlItemId] = !expandedStatus['Evidence' + item.projectControlItemId]">
                  <i [ngClass]="expandedStatus['Evidence' + item.projectControlItemId] ? 'fa fa-fw fa-chevron-circle-down' : 'fa fa-fw fa-chevron-circle-right'"></i>
                  Evidence
                </div>
                <table *ngIf="expandedStatus['Evidence' + item.projectControlItemId]"
                       class="ui-table-scrollable-header-table" style="margin: 5px 0">
                  <thead class="ui-table-thead">
                    <tr style="font-size: 8px;">
                      <th>Evidence</th>
                      <th>Attached</th>
                    </tr>
                  </thead>
                  <tbody class="ui-table-tbody">
                    <tr *ngFor="let evidence of item.evidences">
                      <td style="font-size: 12px;">
                        <span *ngIf="!evidence.name?.startsWith('http://') && !evidence.name?.startsWith('https://') && !evidence.name?.startsWith('\\\\')"
                              (click)="downloadEvidence(item, evidence.name)" class="btn btn-link">{{evidence.name}}</span>
                        <a *ngIf="evidence.name?.startsWith('http://') || evidence.name?.startsWith('https://') || evidence.name?.startsWith('\\\\')"
                           [attr.href]="evidence.name" target="_blank" class="btn btn-link">{{evidence.name}}</a>
                      </td>
                      <td style="font-size: 12px;">{{evidence.date | date : 'MM/dd/yyyy'}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
